"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.number.constructor");








































































var _user = require("@/utils/user");
var _vue = _interopRequireDefault(require("vue"));
var _vSelectpage = _interopRequireDefault(require("v-selectpage")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
_vue.default.use(_vSelectpage.default);var _default = { name: 'TaskSkill', props: { taskId: { type: Number }, flowId: { type: Number } }, data: function data() {return { tableData: [], taskPosData: [], // 列表数据
      groupList: ['A', 'B', 'C', 'E', 'F'], skillListData: [], addPos: false, title: '', delIndex: '', searchData: { page: 1, pageSize: 100, // 页码条数
        rows: 10 }, addData: { skillId: '', taskId: '', flowId: '', groups: '' }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'skillName', label: '技能名', isShow: true }, { prop: 'groups', label: '分组', isShow: true }], rules: { skillId: [{ required: true, message: '请选择技能', trigger: 'blur' }], groups: [{ required: true, message: '请选择分组', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;console.log('s-taskId->', self.taskId);self.handleGetData(self.taskId, self.flowId);self.handleGetSkillData();}, methods: { handleGetData: function handleGetData(taskId, flowId) {var self = this;self.addData.taskId = Number(taskId);
      self.addData.flowId = Number(flowId);
      console.log(self.addData);
      var path = '/api/temi/robot/task/' + taskId + '/flow/' + flowId + '/taskSkill';
      self.getData(path, {}, function (res) {
        self.tableData = res;
      });
    },
    handleGetSkillData: function handleGetSkillData() {
      var self = this;
      self.getData('/api/temi/robot/skillList', self.searchData, function (res) {
        self.skillListData = res;
      });
    },
    handleRowClick: function handleRowClick(row, column, event) {
      console.log(row);
      this.$emit('handleGetParams', row);
    },
    checkPermission: _user.checkPermission,
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addPos = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addPos'].resetFields();
      this.cleanData();
      this.addPos = false;
    },
    updateMenu: function updateMenu(pos) {// 修改操作
      this.title = '修改';
      var self = this;
      self.addPos = true;
      self.addData = {
        id: pos.id,
        name: pos.name,
        taskId: pos.taskId };

    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addPos.validate(function (valid) {
        if (valid) {
          console.log(self.addData);
          var taskId = self.addData.taskId;
          var flowId = self.addData.flowId;
          var path = '/api/temi/robot/task/' + taskId + '/flow/' + flowId + '/taskSkill';
          self.postData(path, self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.handleGetData(taskId, flowId);
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(skillId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var path = '/api/temi/robot/task/' + self.addData.taskId + '/flow/' + self.addData.flowId + '/taskSkill/' + skillId;
        self.delData(path, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.$emit('handleClearParams');
          self.handleGetData(self.addData.taskId, self.addData.flowId);
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addPos = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData.name = '';
    } } };exports.default = _default;